module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('list-popover', {
    ref: "popover",
    attrs: {
      "parent": _vm.parent,
      "direction": _vm.direction,
      "currentValue": _vm.currentValue,
      "multiSelect": _vm.multiSelect,
      "align": "center",
      "list": _vm.list
    },
    on: {
      "select": _vm.selectOption
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c56c205a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/popover/builderComponents/SelectPopover.vue
// module id = 1983
// module chunks = 0